import { removeToken } from 'helpers/common.helper';
import React, { useRef, useState } from 'react';
import { NavLink, useLocation, useNavigate } from 'react-router-dom';
import { Button, Container, Nav, Navbar, NavbarBrand } from 'reactstrap';
import { storeMe } from 'store/global/action';
import { useAppDispatch } from 'store/hooks';
import routes from '../../routes';
import './Navbars.scss';

const Navbars = (props: any) => {
  const dispatch = useAppDispatch();
  const sidebarToggle = useRef(null);
  const location = useLocation();
  const navigate = useNavigate();

  const [isOpen, setIsOpen] = useState(false);

  const getBrand = () => {
    let brandName = '';

    routes.map((item) => {
      if (window.location.href.indexOf(item.path) !== -1) {
        brandName = item.name;
      }
      return null;
    });

    return brandName;
  };

  const handleLogOut = () => {
    dispatch(storeMe(undefined));
    removeToken();
    navigate('/login');
  };

  const activeRoute = (routeName: any) => {
    return location.pathname.indexOf(routeName) > -1 ? 'active' : '';
  };

  return (
    <Navbar
      color="transparent"
      expand="lg"
      className="navbar-absolute fixed-top navbar-transparent"
    >
      <Container fluid>
        <div className="navbar-wrapper">
          <div className="navbar-toggle">
            <button
              type="button"
              ref={sidebarToggle}
              className="navbar-toggler"
              onClick={() => setIsOpen(true)}
            >
              <span className="navbar-toggler-bar bar1" />
              <span className="navbar-toggler-bar bar2" />
              <span className="navbar-toggler-bar bar3" />
            </button>
          </div>

          <NavbarBrand href="/">{getBrand()}</NavbarBrand>
        </div>

        <div className={`drawer ${isOpen ? 'open' : ''}`}>
          <div>
            <Button
              close
              className="close-btn"
              onClick={() => setIsOpen(false)}
            />
            <Nav vertical>
              {props.routes?.length > 0 &&
                props.routes.map((item: any, key: any) => {
                  return (
                    <li
                      className={
                        activeRoute(item.path) + (item.pro ? ' active-pro' : '')
                      }
                      key={key}
                    >
                      <NavLink to={item.path} className="nav-NavLink">
                        <i className={item.icon} />
                        <p>{item.name}</p>
                      </NavLink>
                    </li>
                  );
                })}
            </Nav>
          </div>
          <Button className="btn btn-danger" onClick={handleLogOut}>
            Log Out
          </Button>
        </div>
      </Container>
    </Navbar>
  );
};

export default Navbars;
